import { render, staticRenderFns } from "./FooterV2.vue?vue&type=template&id=b2e00c3e&scoped=true"
import script from "./FooterV2.vue?vue&type=script&lang=js"
export * from "./FooterV2.vue?vue&type=script&lang=js"
import style0 from "./FooterV2.vue?vue&type=style&index=0&id=b2e00c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e00c3e",
  null
  
)

export default component.exports